// Module
var code = "<h1 id=\"账户\">账户</h1> <p>或许你已经注意到，本区块链技术要求你注册一个账户名。这带来很多好处：这不仅增强了系统的可扩展性，同时我们可以将身份标示与交易授权签名分开。事实上，<em>拥有一个账户名<em>和能够</em>花费它的资金<em>是相互独立的。而且，这两种权利 (我们称之为</em>权限</em>)能够分散赋予任意复杂的人群关系中。我们称之为<em>职权实体</em>你可通过分配<em>权重</em>和设定 <em>门槛阀值</em>来实现。</p> ";
// Exports
export default code;